import { colors } from '@/theme/colors';

export default function Maintenance() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4118 12.3141C20.2068 11.5162 20.7349 10.4915 20.9233 9.38112C21.1117 8.27071 20.9511 7.12921 20.4638 6.11381L17.6962 8.881C17.3548 9.22252 16.8916 9.41443 16.4087 9.41451C15.9257 9.41458 15.4625 9.22282 15.1209 8.8814C14.7793 8.53999 14.5874 8.07689 14.5873 7.59398C14.5873 7.11107 14.779 6.6479 15.1205 6.30638L17.888 3.53919C16.8732 3.04983 15.7314 2.88811 14.6206 3.07642C13.5098 3.26473 12.4851 3.79376 11.6883 4.59022C10.8916 5.38669 10.3623 6.41117 10.1737 7.52178C9.98512 8.63238 10.1466 9.77414 10.6358 10.7889L3.53329 17.8922C3.19183 18.2336 3 18.6966 3 19.1795C3 19.6623 3.19183 20.1254 3.53329 20.4668C3.87474 20.8082 4.33786 21 4.82075 21C5.30365 21 5.76676 20.8082 6.10822 20.4668L13.2124 13.3651C14.2276 13.8522 15.3689 14.0126 16.4791 13.8244C17.5893 13.6362 18.6138 13.1085 19.4118 12.3141Z"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 9L18 12"
        stroke={colors.neutral10}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
